import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4A5568",
      "fill-rule": "evenodd",
      d: "M15.657 15.657A8 8 0 1 1 4.343 4.342a8 8 0 0 1 11.314 11.315M10.2 12.166v1.09q0 .439.2.668a.7.7 0 0 0 .533.223.7.7 0 0 0 .533-.217q.2-.223.199-.674v-1.09h.357q.446 0 .668-.152.223-.159.223-.498 0-.416-.275-.54-.27-.123-.721-.123h-.252V6.319q0-1.02-.89-1.02a.67.67 0 0 0-.475.188 5 5 0 0 0-.498.592l-3.106 4.154-.217.288q-.087.117-.17.246a1 1 0 0 0-.122.24.6.6 0 0 0-.042.223q0 .433.276.685.281.252.838.252zm-2.52-1.312h2.52V7.449z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }